"use client";
import PageCta from "@/components/shared/page-cta";
import { useTranslations } from "next-intl";

const ServicesCta = () => {
  const t = useTranslations("services");
  return (
    <PageCta
      title={t("cta.title")}
      description={t("cta.description")}
      primaryLabel={t("cta.button")}
    />
  );
};

export default ServicesCta;
